<template>
	<div class="authorized-service pb-5">
		<div class="container py-lg-3">
			<div class="row">
				<div class="col-12 authorized-service-cover">
					<div class="row">
						<div class="col-12 col-lg-8 offset-lg-2 text-sm-center">
							<h1 class="mt-md-5 d-inline d-sm-block align-top">
								Autoryzowany Serwis
							</h1>
							<img :src="'assets/images/'+logo" alt="" class="d-inline d-sm-block mt-lg-4 mb-2 mb-md-5 mx-sm-auto align-bottom service-logo">
							<h6 class="text-gray">
								na terenie Warszawy i okolic.
							</h6>
							<a href="#contact" v-scroll-to="{ el: '#contact', duration: 700}" class="btn btn-gradient mt-3" @click="tracking">
								Zamów wizytę
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'AuthorizedService',
		props: {
			logo: String
		},
		methods: {
			tracking() {
				this.$gtag.event('Klik', {
					'event_category': 'CTA',
					'event_label': 'Zamów wizytę',
					'non_interaction': true
				})
			}
		}
	}
</script>

<style lang="scss">
	.authorized-service-cover{
		background-image: url('../assets/images/ango-mobile.jpg');
		background-size: calc(100% - 30px) auto;
		background-repeat: no-repeat;
		padding-top: 65vw;
		background-position: center top;
		.service-logo{
			max-width: 130px;
		}
		@include media-breakpoint-up(sm){
			padding-top: 375px;
		}
		@include media-breakpoint-up(md){
			padding-top: 0;
			background-position: top center;
			background-image: url('../assets/images/authorized-service.jpg');
			.service-logo{
				max-width: initial;
			}
		} 
	}
</style>